import {useEffect} from 'react';
import debounce from 'lodash.debounce';

const calculateScrollPercentage = () => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const scrollHeight =
    document.documentElement.scrollHeight - document.documentElement.clientHeight;
  return scrollTop / scrollHeight;
};

/**
 * Custom hook that listens for scroll events and triggers a callback
 * when the user scrolls to 90% of the page height.
 *
 * @param {Object} params - The parameters for the hook.
 * @param {Function} params.callback - The function to call when the scroll threshold is reached.
 * @param {Array} params.dependencies - The dependencies array for the useEffect hook.
 */

const useScrollListener = ({callback, dependencies}) => {
  useEffect(() => {
    const handleScroll = debounce(() => {
      if (calculateScrollPercentage() >= 0.9) {
        callback();
      }
    }, 100);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, dependencies);
};

export default useScrollListener;
